import { Component, OnInit } from '@angular/core';

import { NxButtonModule } from '@allianz/ng-aquila/button';
import { NxPopoverModule } from '@allianz/ng-aquila/popover';
import { NxIconModule } from '@allianz/ng-aquila/icon';
import { DarkModeComponent } from '../dark-mode/dark-mode.component';

@Component({
  selector: 'app-accessibility',
  standalone: true,
  imports: [
    NxButtonModule,
    NxPopoverModule,
    NxIconModule,
    DarkModeComponent
],
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.css']
})
export class AccessibilityComponent implements OnInit {
  currentFontSize = 'sm';
  private readonly fontSizes: string[] = ['sm', 'md', 'lg'];
  isPopoverOpen = false;

  ngOnInit(): void {
    const savedFontSize = localStorage.getItem('fontSizePreference');
    if (savedFontSize) {
      this.currentFontSize = savedFontSize;
      this.applyFontSize(savedFontSize);
    } else {
      this.applyFontSize('sm');
    }
  }

  onButtonClick(): void {
    this.isPopoverOpen = !this.isPopoverOpen;
  }

  onPopoverToggle(event: unknown): void {
    let isOpen: boolean;
    
    if (typeof event === 'boolean') {
      isOpen = event;
    } else if (event && typeof event === 'object') {
      const eventObj = event as Record<string, unknown>;
      isOpen = !!(eventObj['opened'] || eventObj['value'] || eventObj['isOpen']);
    } else {
      isOpen = false;
    }
    
    this.isPopoverOpen = isOpen;
  }

  setFontSize(size: string): void {
    this.currentFontSize = size;
    this.applyFontSize(size);
    localStorage.setItem('fontSizePreference', size);
  }

  increaseFontSize(): void {
    const currentIndex = this.fontSizes.indexOf(this.currentFontSize);
    if (currentIndex < this.fontSizes.length - 1) {
      const nextSize = this.fontSizes[currentIndex + 1];
      this.setFontSize(nextSize);
    }
  }

  decreaseFontSize(): void {
    const currentIndex = this.fontSizes.indexOf(this.currentFontSize);
    if (currentIndex > 0) {
      const prevSize = this.fontSizes[currentIndex - 1];
      this.setFontSize(prevSize);
    }
  }

  isIncreaseFontSizeDisabled(): boolean {
    const currentIndex = this.fontSizes.indexOf(this.currentFontSize);
    return currentIndex >= this.fontSizes.length - 1;
  }

  isDecreaseFontSizeDisabled(): boolean {
    const currentIndex = this.fontSizes.indexOf(this.currentFontSize);
    return currentIndex <= 0;
  }

  private applyFontSize(size: string): void {
    document.body.classList.remove('font-sm', 'font-md', 'font-lg');
    document.body.classList.add(`font-${size}`);
  }

  getFontSizeLabel(size: string): string {
    switch (size) {
      case 'sm': return 'Small (12px)';
      case 'md': return 'Medium (16px)';
      case 'lg': return 'Large (48px)';
      default: return '';
    }
  }
}
